import React, { forwardRef, useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Services.css";
import newservices from "../../Assets/newservices.jpeg";
import AdjustIcon from '@mui/icons-material/Adjust';

const Services = forwardRef((props, ref) => {

    const boxContainerRef = useRef(null);
    const [scrollProgress, setScrollProgress] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = (event) => {
            if (boxContainerRef.current) {
                const boxContainer = boxContainerRef.current;
                const rect = boxContainer.getBoundingClientRect();

                const inView = rect.top < window.innerHeight / 2 && rect.bottom > window.innerHeight / 2;

                if (inView) {
                    event.preventDefault();
                    boxContainer.scrollLeft += event.deltaY;

                    const scrollLeft = boxContainer.scrollLeft;
                    const maxScrollLeft = boxContainer.scrollWidth - boxContainer.clientWidth;
                    const progress = maxScrollLeft > 0 ? (scrollLeft / maxScrollLeft) * 100 : 0;

                    setScrollProgress(progress);

                    if (
                        (event.deltaY < 0 && boxContainer.scrollLeft === 0) ||
                        (event.deltaY > 0 && boxContainer.scrollLeft + boxContainer.clientWidth >= boxContainer.scrollWidth)
                    ) {
                        window.scrollBy(0, event.deltaY);
                    }
                }
            }
        };

        window.addEventListener("wheel", handleScroll, { passive: false });

        return () => {
            window.removeEventListener("wheel", handleScroll);
        }

    }, []);

    const servicesData = [
        {
            title: "Franchise Expansion",
            points: [
                "Rapid Franchise Scaling Systems",
                "High-Volume Lead Pipelines",
                "Multi-Platform Brand Domination",
                "Sales Onboarding & Expansion Support"
            ],
            navigateTo: "/serviceFB"
        },
        {
            title: "Digital Marketing",
            points: [
                "Meta Ads Campaign & Content creation",
                "LinkedIn & YouTube Ads",
                "TikTok Ads",
                "Google SEO & Paid Ads"
            ],
            navigateTo: "/serviceDM"
        },
        {
            title: "Website Development",
            points: [
                "Fully coded Website",
                "Website Management & Modification",
                "Landing pages",
                "UI Designs"
            ],
            navigateTo: "/serviceWEB"
        },
        {
            title: "Offline Marketing",
            points: [
                "Print & Event Marketing",
                "Outdoor Advertisments",
                "Sales training",
                "Networking and relationship building"
            ],
            navigateTo: "/serviceOM"
        },
        {
            title: "Strategy Building",
            points: [
                "Campaigns & Content Roadmap",
                "Campaign Audits",
                "Conversion Rate Optimisation",
                "CRM Solutions"
            ],
            navigateTo: "/serviceSB"
        },
        {
            title: "Business Consultation",
            points: [
                "Industry & Market Analysis",
                "Management Consultation",
                "Business Roadmap",
                "Competitor Analysis"
            ],
            navigateTo: "/serviceBC"
        }
    ];

    const handleBoxClick = (path) => {
        if (path) {
            navigate(path);
        }
    };

    return (
        <>

            <div ref={ref} className="service-container">
                <div className="service-left">
                    <img className="service-image" src={newservices} alt="Banner" />
                </div>
                <div className="service-right">
                    <h1 className="Topic">
                        Our Services
                    </h1>
                    <div className="service-wrapper">
                        <div ref={boxContainerRef} className="box-container">
                            {servicesData.map((services, index, array) => (
                                <React.Fragment key={services}><div key={services.title} className="procBox"
                                    onClick={() => handleBoxClick(services.navigateTo)}
                                >
                                    <h1 className="Box-Topic">{services.title}</h1>
                                    <span className="box-subTopic">
                                        <ul className="serv-ul">
                                            {services.points.map((points, i) => (
                                                <li className="serv-points" key={i}>{points}</li>
                                            ))}
                                        </ul>
                                    </span>
                                </div>
                                    {index < array.length - 1 && (
                                        <div className="arrow-container">
                                            <AdjustIcon className="adjust-icon" />
                                        </div>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                    <div className="serv-progress-bar-container">
                        <div className="progress-bar" style={{ width: `${scrollProgress}%` }}></div>
                    </div>
                </div>
            </div>
        </>
    )
});

export default Services;